import enUS from 'antd/lib/locale/en_US';
import deDE from 'antd/lib/locale/de_DE';
import frFR from 'antd/lib/locale/fr_FR';
import esES from 'antd/lib/locale/es_ES';
import nlNL from 'antd/lib/locale/nl_NL';
import daDK from 'antd/lib/locale/da_DK';
import nbNO from 'antd/lib/locale/nb_NO';
import csCZ from 'antd/lib/locale/cs_CZ';
import jaJP from 'antd/lib/locale/ja_JP';

export const TRANSLATION_LANGUAGE = {
  EN: 'en',
  EN_US: 'en-US',
  DE: 'de',
  FR: 'fr',
  ES: 'es',
  NL: 'nl',
  DK: 'da',
  NO: 'no-NO',
  CZ: 'cs',
  JP: 'ja-JP'
};

export const DEFAULT_TRANSLATION_LANGUAGE = TRANSLATION_LANGUAGE.EN;

export const TRANSLATION_LANGUAGE_LIST = [
  {
    name: 'English',
    value: TRANSLATION_LANGUAGE.EN,
    code: 'UK',
    icon: 'united-kingdom'
  },
  {
    name: 'American English',
    value: TRANSLATION_LANGUAGE.EN_US,
    code: 'USA',
    icon: 'usa'
  },
  {
    name: 'Deutsch',
    value: TRANSLATION_LANGUAGE.DE,
    code: 'DE',
    icon: 'germany'
  },
  {
    name: 'French',
    value: TRANSLATION_LANGUAGE.FR,
    code: 'FR',
    icon: 'france'
  },
  {
    name: 'Spanish',
    value: TRANSLATION_LANGUAGE.ES,
    code: 'ES',
    icon: 'spain'
  },
  {
    name: 'Netherlands',
    value: TRANSLATION_LANGUAGE.NL,
    code: 'NL',
    icon: 'netherlands'
  },
  {
    name: 'Denmark',
    value: TRANSLATION_LANGUAGE.DK,
    code: 'DK',
    icon: 'denmark'
  },
  {
    name: 'Norway',
    value: TRANSLATION_LANGUAGE.NO,
    code: 'NO',
    icon: 'norway'
  },
  {
    name: 'Czech Republic',
    value: TRANSLATION_LANGUAGE.CZ,
    code: 'CZ',
    icon: 'czech-republic'
  },
  {
    name: 'Japan',
    value: TRANSLATION_LANGUAGE.JP,
    code: 'JP',
    icon: 'japan'
  }
];

export const COMMON_NAMESPACE = 'common';

export const TRANSLATION_NAMESPACES = {
  OVERVIEW: 'overview',
  CLAIMING_PROCESS: 'claimingProcess',
  MY_MACHINE: 'myMachine',
  MACHINE_DETAILS: 'machineDetails',
  CLEANING_REPORT: 'cleaningReport',
  NOTIFICATION: 'notification',
  OPERATOR: 'operator',
  COMMON: 'common',
  AUTHENTICATION: 'authentication',
  NOTIFICATION_CODES: 'notificationCodes'
};

export const MAPPING_ANTD_LOCALE_BY_LANGUAGE = {
  [TRANSLATION_LANGUAGE.EN]: enUS,
  [TRANSLATION_LANGUAGE.EN_US]: enUS,
  [TRANSLATION_LANGUAGE.DE]: deDE,
  [TRANSLATION_LANGUAGE.FR]: frFR,
  [TRANSLATION_LANGUAGE.ES]: esES,
  [TRANSLATION_LANGUAGE.NL]: nlNL,
  [TRANSLATION_LANGUAGE.DK]: daDK,
  [TRANSLATION_LANGUAGE.NO]: nbNO,
  [TRANSLATION_LANGUAGE.CZ]: csCZ,
  [TRANSLATION_LANGUAGE.JP]: jaJP
};

export const KIRA_LOCAL_STORAGE_NAME = 'kiraI18nextLng';

export const LOADING_TRANSLATION_FILE_TEXT = {
  [TRANSLATION_LANGUAGE.EN]: 'Loading...',
  [TRANSLATION_LANGUAGE.EN_US]: 'Loading...',
  [TRANSLATION_LANGUAGE.DE]: 'Wird geladen...',
  [TRANSLATION_LANGUAGE.FR]: 'Chargement...',
  [TRANSLATION_LANGUAGE.ES]: 'Cargando...',
  [TRANSLATION_LANGUAGE.NL]: 'Loading...',
  [TRANSLATION_LANGUAGE.DK]: 'Loading...',
  [TRANSLATION_LANGUAGE.NO]: 'Loading...',
  [TRANSLATION_LANGUAGE.CZ]: 'Loading...',
  [TRANSLATION_LANGUAGE.JP]: 'Loading...'
};

export const REGISTRATION_LINK_LANGUAGE_CODE_MAP = {
  [TRANSLATION_LANGUAGE.EN]: 'en',
  [TRANSLATION_LANGUAGE.EN_US]: 'en',
  [TRANSLATION_LANGUAGE.DE]: 'de',
  [TRANSLATION_LANGUAGE.FR]: 'en',
  [TRANSLATION_LANGUAGE.ES]: 'en',
  [TRANSLATION_LANGUAGE.NL]: 'en',
  [TRANSLATION_LANGUAGE.DK]: 'en',
  [TRANSLATION_LANGUAGE.NO]: 'en',
  [TRANSLATION_LANGUAGE.CZ]: 'en',
  [TRANSLATION_LANGUAGE.JP]: 'en'
};
